module.exports = __webpack_public_path__ + "static/media/de.25e7473f.svg";